'use client'
const DynamicSettingsViews = ['settings'];
const DynamicGlobalWalletViews = [
    'global-wallet',
    'connected-apps',
];
const DynamicPasskeyWidgetViews = ['manage-passkeys'];
const DynamicMfaWidgetViews = ['manage-mfa'];
const DynamicTransactionsWidgetViews = ['send-balance'];

export { DynamicGlobalWalletViews, DynamicMfaWidgetViews, DynamicPasskeyWidgetViews, DynamicSettingsViews, DynamicTransactionsWidgetViews };
